
/**
 * Generate a random int between min (inclusive) and max (exclusive)
 */
export function rand(min,max) {
  return Math.floor(Math.random()*(max-min))+min;
}

/**
* Shuffles array in place.
* @param {Array} a items The array containing the items.
* @see {@link http://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array-in-javascript}
*/
export function shuffle(a) {
  var j, x, i;
  for (i = a.length; i; i -= 1) {
      j = Math.floor(Math.random() * i);
      x = a[i - 1];
      a[i - 1] = a[j];
      a[j] = x;
  }
  return a;
}

/**
 * Get params from URL query string
 * @param {string} URL Query string e.g. ?foo=bar&baz=ban
 * @see {@link http://stackoverflow.com/a/3855394}
 * @see {@link http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript/3855394#3855394}
 */
export const getParams = query => {
  if (!query) {
    return { };
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, { });
};



// WEBPACK FOOTER //
// ./src/js/util.js